// src/store/useSidePanelStore.ts
import { create } from 'zustand';

type SidePanelState = {
  isPanelOpen: boolean;
  setIsPanelOpen: (isOpen: boolean) => void;
  updatePanelOpen: (isOpen: boolean) => void;
};

const useSidePanelStore = create<SidePanelState>(set => ({
  isPanelOpen: true,
  setIsPanelOpen: isOpen => set({ isPanelOpen: isOpen }),
  updatePanelOpen: () => {
    console.warn('updatePanelOpen not connected yet');
  },
}));

export default useSidePanelStore;
